import { createReducer, on } from '@ngrx/store';
import * as DailyCheckinActions from './daily-checkin.actions';
import { MaintenanceScheduleDto } from '../../../../api/gse/models/maintenance-schedule-dto';
import { DailyCheckinListItem } from '../../../../core/services/gse/daily-checkin.service';

export const dailyCheckinFeatureKey = 'dailyCheckin';

export interface DailyCheckinState {
  items: DailyCheckinListItem[];
  totalRecords: number;
  loading: boolean;
  error: string | null;

  lastQuery: import('../../../../core/services/gse/daily-checkin.service').DailyCheckinListQuery | null;

  selectedId: number | null;
  scheduleLoading: boolean;
  selectedSchedule: MaintenanceScheduleDto | null;
  scheduleError: string | null;

  submitting: boolean;
  submitSuccess: boolean;
  submitError: string | null;
}

export const initialState: DailyCheckinState = {
  items: [],
  totalRecords: 0,
  loading: false,
  error: null,

  lastQuery: null,

  selectedId: null,
  scheduleLoading: false,
  selectedSchedule: null,
  scheduleError: null,

  submitting: false,
  submitSuccess: false,
  submitError: null,
};

export const dailyCheckinReducer = createReducer(
  initialState,
  on(DailyCheckinActions.loadDailyCheckins, (state, { query, silent }) => ({
    ...state,
    loading: silent ? state.loading : true,
    error: null,
    lastQuery: query,
    items: silent ? state.items : [],
    totalRecords: silent ? state.totalRecords : 0,
    selectedId: silent ? state.selectedId : null,
    selectedSchedule: silent ? state.selectedSchedule : null,
    scheduleError: silent ? state.scheduleError : null,
  })),
  on(DailyCheckinActions.loadDailyCheckinsSuccess, (state, { result }) => ({
    ...state,
    items: result.items,
    totalRecords: result.totalRecords,
    loading: false,
    error: null,
  })),
  on(DailyCheckinActions.loadDailyCheckinsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    items: [],
    totalRecords: 0,
    selectedId: null,
    selectedSchedule: null,
  })),

  on(DailyCheckinActions.selectDailyCheckinItem, (state, { id }) => ({
    ...state,
    selectedId: id,
    selectedSchedule: null,
    scheduleError: null,
  })),

  on(DailyCheckinActions.loadMaintenanceSchedule, (state) => ({
    ...state,
    scheduleLoading: true,
    scheduleError: null,
    selectedSchedule: null,
  })),
  on(DailyCheckinActions.loadMaintenanceScheduleSuccess, (state, { schedule }) => ({
    ...state,
    scheduleLoading: false,
    selectedSchedule: schedule,
  })),
  on(DailyCheckinActions.loadMaintenanceScheduleFailure, (state, { error }) => ({
    ...state,
    scheduleLoading: false,
    scheduleError: error,
  })),

  on(DailyCheckinActions.createMaintenanceScheduleJobCard, (state) => ({
    ...state,
    submitting: true,
    submitSuccess: false,
    submitError: null,
  })),
  on(DailyCheckinActions.createMaintenanceScheduleJobCardSuccess, (state) => ({
    ...state,
    submitting: false,
    submitSuccess: true,
  })),
  on(DailyCheckinActions.createMaintenanceScheduleJobCardFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    submitError: error,
  })),

  on(DailyCheckinActions.updateMaintenanceScheduleDailyCheckin, (state) => ({
    ...state,
    submitting: true,
    submitSuccess: false,
    submitError: null,
  })),
  on(DailyCheckinActions.updateMaintenanceScheduleDailyCheckinSuccess, (state) => ({
    ...state,
    submitting: false,
    submitSuccess: true,
  })),
  on(DailyCheckinActions.updateMaintenanceScheduleDailyCheckinFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    submitError: error,
  }))
);
